// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-header[data-v-43d18e58]{margin-bottom:0}.rounded-top[data-v-43d18e58]{border-radius:25px 25px 0 0}", ""]);
// Exports
module.exports = exports;
